export const parseDate = (dateString) => {
  if (!dateString) return null;

  // If the dateString is a Date object, return it directly
  if (dateString instanceof Date) return dateString;

  // If the dateString is a string, parse it
  if (typeof dateString === "string") {
    const [day, month, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  }

  return null;
};
